import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { SupportEnvironment } from './support-environment'

export type SupportResource = 'meetings' | 'users' | 'teams'

// Exactly one of the two is set: a row from the serving environment routes internally, a row from
// another environment has to leave this origin entirely.
export type SupportLink = { routerLink: unknown[]; href: null } | { routerLink: null; href: string }

/**
 * Drilling into a row is where a merged list stops being uniform: the environment that owns the row
 * owns its detail page too. Each app provides the resolver that matches how it reaches those pages.
 *
 * Kept free of app-specific imports so that pulling the token into a consumer does not pull that
 * app's services in with it.
 */
@Injectable()
export abstract class SupportLinkResolver {
  abstract canFollowSupportLinks(): Observable<boolean>
  abstract linkTo(environment: SupportEnvironment | undefined, resource: SupportResource, id: number): SupportLink
}

export function supportLinkFor(environment: SupportEnvironment, resource: SupportResource, id: number): SupportLink {
  if (environment.origin === '') {
    return { routerLink: ['/app', 'support', resource, id], href: null }
  }
  return { routerLink: null, href: `${environment.origin}/app/support/${resource}/${id}` }
}
